<div
  class="min-h-screen w-full flex flex-col items-center justify-center bg-gray-50 relative"
>
  <div
    class="w-[60%] max-w-5xl bg-white rounded-2xl shadow-[0_5px_25px_rgba(0,0,0,0.15)] overflow-hidden flex flex-col lg:flex-row h-[100%] my-[10vh] mx-[40vw] z-10"
  >
    <div
      class="login-left-panel w-full lg:w-[45%] bg-gray-50 flex flex-col text-center order-last lg:order-first border-t lg:border-t-0 lg:border-r border-gray-100"
    >
      <div
        class="hidden lg:flex justify-center items-center bg-[--primary-500] h-[25%] rounded-tl-2xl p-6 transition-colors duration-500"
      >
        <img
          [src]="logoUrl$ | async"
          class="max-w-[80%] max-h-[60px] object-contain drop-shadow-md"
          alt="Tenant Logo"
        />
      </div>

      <div class="w-full mt-6 lg:mt-0 p-8 rounded-bl-2xl border h-[75%]">
        <p-carousel
          [value]="features"
          [numVisible]="1"
          [numScroll]="1"
          [circular]="true"
          [showIndicators]="true"
          [autoplayInterval]="5000"
          styleClass="custom-carousel mb-8"
        >
          <ng-template let-feature pTemplate="item">
            <div class="flex flex-col items-center gap-4 px-5 select-none">
              <div
                class="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-2 w-full flex justify-center items-center aspect-[4/3] max-h-[200px] lg:max-h-[260px]"
              >
                <img
                  [src]="feature.image"
                  [alt]="feature.title"
                  class="w-full h-full object-contain rounded-lg"
                />
              </div>
              <div class="space-y-2 max-w-xs mx-auto">
                <h3 class="text-xl font-bold text-gray-800">
                  {{ feature.title }}
                </h3>
                <p class="text-sm text-gray-500 leading-relaxed">
                  {{ feature.text }}
                </p>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>

    <div
      class="login-form-panel w-full lg:w-[55%] flex flex-col justify-center items-center p-6 sm:p-8 lg:p-12 bg-white"
    >
      <div
        class="lg:hidden flex items-center justify-center bg-[--primary-500] rounded-xl p-4 mb-8 w-full max-w-[280px] mx-auto shadow-md transition-colors duration-500"
      >
        <img
          [src]="logoUrl$ | async"
          class="max-w-full max-h-[45px] object-contain drop-shadow-md"
          alt="Tenant Logo"
        />
      </div>

      <div class="w-full max-w-md mx-auto">
        <div class="mb-8 text-center lg:text-left">
          <h2 class="text-3xl font-bold text-gray-900 mb-2">{{ pageTitle }}</h2>
          <p class="text-gray-500 text-sm" *ngIf="subtitle">
            {{ subtitle }}
            <a
              [routerLink]="[actionLinkRoute]"
              class="text-[--primary-500] font-bold hover:text-[--primary-700] hover:underline cursor-pointer transition-colors ml-1"
            >
              {{ actionLinkText }}
            </a>
          </p>
        </div>

        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <app-footer [isLoginMode]="true"></app-footer>
</div>
